import { Pagination } from './pagination'
import { Store } from './store'

export type PagedUsers = {
  items: User[]
  pagination: Pagination
}

export type User = {
  userId: string
  cognitoId: string
  snsId: string
  name: string
  profileImage: string
  phoneNumber: string
  email: string
  snsType: SnsType
  userAuthorityType: UserAuthType
  companyName: string
  jobPosition: string
  snsToken: string
  notificationToken: string
  snsEndpointArn: string
  businessRegistrationImage: string
  recommenderCode: number
  createdAt: string
  updatedAt: string
  favoriteLikes: UserFavoriteLikes[]
  managerStores: Store[]

  accessToken: string
  refreshToken: string
  expiresIn: number
  keepLoggedIn: boolean
  is2FAEnabled: boolean
}

export type UserFavoriteLikes = {
  id: string
  userId: string
  storeId: string
  promotionId: string
  isFavorite: boolean
  isLike: boolean
  createdAt: string
}

export enum UserAuthType {
  User = 0,
  Manager = 1,
  Admin = 2,
  Designer = 3,
}

export enum SnsType {
  None = 0,
  Apple = 1,
  Kakao = 2,
  Naver = 3,
  Google = 4,
}
